/* eslint-disable max-len */
import React from 'react';

const FormattingIcon = (props: any) => (
  <svg
    width="20"
    height="14"
    viewBox="0 0 20 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.451 12.9978H11.372L6.656 0.507812H4.699L0 12.9978H1.834L2.987 9.85377H8.298L9.451 12.9978ZM7.739 8.29878H3.546L5.642 2.5698L7.739 8.29878ZM13.835 12.9191C14.312 13.1571 14.859 13.2771 15.476 13.2771C16.105 13.2771 16.673 13.1521 17.181 12.9021C17.687 12.6511 18.097 12.3051 18.412 11.8631V12.9981H20.001V7.58311C20.001 6.87311 19.844 6.25211 19.529 5.72311C19.214 5.19311 18.775 4.78011 18.21 4.48311C17.645 4.18611 16.979 4.03711 16.21 4.03711C14.835 4.03711 13.635 4.53211 12.611 5.52211L13.625 6.60511C14.347 5.83611 15.162 5.45211 16.07 5.45211C16.792 5.45211 17.354 5.65011 17.756 6.04511C18.157 6.44111 18.358 6.97111 18.358 7.63511H16.175C14.987 7.63511 14.049 7.88811 13.363 8.39511C12.675 8.90211 12.332 9.60311 12.332 10.5001C12.332 11.0351 12.463 11.5121 12.725 11.9321C12.987 12.3501 13.357 12.6801 13.835 12.9191ZM17.389 11.4511C16.941 11.7601 16.42 11.9141 15.826 11.9141C15.302 11.9141 14.885 11.7781 14.579 11.5031C14.27 11.2301 14.116 10.8721 14.116 10.4301C14.116 9.94111 14.31 9.56011 14.701 9.28611C15.09 9.01211 15.635 8.87511 16.334 8.87511H18.359V10.2201C18.161 10.7321 17.838 11.1421 17.389 11.4511Z"
      fill="currentColor"
    />
  </svg>
);

export default FormattingIcon;
